import React, { useEffect, useState } from 'react';
import './CookieConsent.css';

const STORAGE_KEY = 'milchkettenmusik-cookie-consent';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const consent = window.localStorage.getItem(STORAGE_KEY);
      if (!consent) {
        setIsVisible(true);
      }
    } catch (error) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (error) {
      // Ignore write errors (e.g., private mode)
    }
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent" role="dialog" aria-live="polite">
      <div className="cookie-consent__text">
        Wir verwenden Cookies, um dir eine optimale Nutzung unserer Website zu ermöglichen. Informationen zu
        künftigen Analyse-Tools und zur Verarbeitung deiner Daten findest du in unserer{' '}
        <a href="/datenschutz.html">Datenschutzerklärung</a>.
      </div>
      <button type="button" className="cookie-consent__button" onClick={handleAccept}>
        Einverstanden
      </button>
    </div>
  );
}

export default CookieConsent;
